import * as React from 'react';
import { connect } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addLocaleData, IntlProvider } from 'react-intl';
import * as localeDa from 'react-intl/locale-data/da';
import * as localeDe from 'react-intl/locale-data/de';
import * as localeEn from 'react-intl/locale-data/en';
import * as localeEs from 'react-intl/locale-data/es';
import * as localeFr from 'react-intl/locale-data/fr';
import * as localeIt from 'react-intl/locale-data/it';
import * as localeNl from 'react-intl/locale-data/nl';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { stripeKey } from './config';
import { getMessages, PagePath } from './helpers/util';
import { Complete, MySubscriptions, Plans, NoSubscription, UserHasIap } from './pages';
import { HeaderBar } from './components/index';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

addLocaleData([...localeNl, ...localeEn, ...localeFr, ...localeDe, ...localeEs, ...localeIt, ...localeDa]);

const mapStateToProps = (state: any) => ({
  language: state.appData.language,
});
type Props = ReturnType<typeof mapStateToProps>;

const stripePromise = loadStripe(stripeKey);
class App extends React.Component<Props> {
  public render() {
    return (
      <IntlProvider locale={this.props.language} messages={getMessages(this.props.language)}>
        <>
          <HeaderBar />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <HashRouter>
            <Elements stripe={stripePromise}>
              <Switch>
                <Route exact={true} path={PagePath.plans} component={Plans} />
                <Route path={PagePath.complete} component={Complete} />
                <Route path={PagePath.mySubscriptions} component={MySubscriptions}/>
                <Route path={PagePath.noB2C} component={NoSubscription} />
                <Route path={PagePath.userHasIap} component={UserHasIap} />
              </Switch>
            </Elements>
          </HashRouter>
        </>
      </IntlProvider>
    );
  }
}

export default connect<Props>(mapStateToProps)(App);
